import LogoDefensoria from '/img/LOGO_DPE_2024_ok.png';
import { AttendanceSheetResponseDto } from '@/api.types';
import { AttendanceSheetStatusEnum } from '../../enums/attendance-sheet-status.enum';
import { Document, Image, Page, Text, View, } from '@react-pdf/renderer';
import { SignatureRoleEnum } from '../../enums/signature-role.enum';
import { attendanceSheetDayEnumInFull } from '../../enums/attendance-sheet-day.enum';
import { dayOfTheWeek } from '@/shared/utils/datas';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { styles } from './AttendanceSheetPDFstyle';

export interface AttendanceSheetPdfProps {
  folha: AttendanceSheetResponseDto;
}

export function AttendanceSheetPdf({ folha }: AttendanceSheetPdfProps) {
  const dataInicial = new Date(folha.ano, folha.mes - 1, 1);

  const assinaturaEstagiario = folha.assinaturas?.find((a) => a.perfilAssinante === SignatureRoleEnum.ESTAGIARIO);
  const assinaturaResponsavel = folha.assinaturas?.find((a) => a.perfilAssinante === SignatureRoleEnum.RESPONSAVEL);

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        <View style={styles.header}>
          {/* Logotipo à esquerda */}
          <Image src={LogoDefensoria} style={styles.logo} />

          {/* Título e subtítulo centralizados */}
          <View style={{ flexGrow: 1, textAlign: 'center' }}>
            <Text style={styles.title}>DEFENSORIA PÚBLICA DO ESTADO DE SERGIPE</Text>
            <Text style={styles.subtitle}>FOLHA DE FREQUÊNCIA - {folha.estagio.curso?.toUpperCase()}</Text>
          </View>
        </View>

        {/* Nome e mês/ano */}
        <View style={styles.infoRow}>
          <Text><Text style={styles.label}>NOME:</Text> {folha.estagiario?.nome || '__________'}</Text>
          <Text><Text style={styles.label}>MÊS E ANO:</Text> {format(dataInicial, 'MMMM/yyyy', { locale: ptBR })}</Text>
        </View>

        {/* CPF e período */}
        <View style={styles.infoRow}>
          <Text>
            <Text style={styles.label}>COMARCA:</Text> {folha.estagio.comarca || '__________'}
          </Text>
          {/* <Text>
            <Text style={styles.label}>FÓRUM:</Text> {folha.estagio.forum || '__________'}
          </Text> */}
        </View>

        {/* Local de estágio */}
        <View style={styles.infoRow}>
          <Text><Text style={styles.label}>LOTAÇÃO:</Text> {folha.estagio?.local || '__________'}</Text>
        </View>

        <View style={styles.infoRow}>
          <Text><Text style={styles.label}>SUPERVISOR:</Text> {folha.responsavel.nome || '__________'}</Text>
        </View>

        {/* Tabela de frequência */}
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCell, styles.tableCellDate]}>DATA</Text>
            <Text style={[styles.tableCell, styles.tableCellTime]}>HORÁRIO DE ENTRADA</Text>
            <Text style={[styles.tableCell, styles.tableCellTime]}>HORÁRIO DE SAÍDA</Text>
            <Text style={[styles.tableCell, styles.tableCellJustification]}>ASSINATURA DO ESTAGIÁRIO OU JUSTIFICATIVA DA FALTA</Text>
          </View>
          {folha.dias.map((dia, index) => {
            const par = index % 2 === 0;
            return (
              <View key={index} style={[par ? styles.tableRow : styles.tableRowEven]}>
                <Text style={[styles.tableCell, styles.tableCellDate]}>{dia.dia}</Text>
                <Text style={[styles.tableCell, styles.tableCellTime]}>{dia.util ? dia.horarioEntrada : 'xxxxx'}</Text>
                <Text style={[styles.tableCell, styles.tableCellTime]}>{dia.util ? dia.horarioSaida : 'xxxxx'}</Text>
                <Text style={[styles.tableCell, styles.tableCellJustification]}>
                  {dia.util ?
                    (dia.justificativa || attendanceSheetDayEnumInFull(dia.status))
                    : dia.feriado || dayOfTheWeek(new Date(folha.ano, folha.mes - 1, dia.dia))
                  }
                </Text>
              </View>
            );
          })}
        </View>

        <View style={styles.rodapemessage}>
          <Text>Declaro que todas as informações contidas neste formulário são verdadeiras.</Text>
        </View>

        {/* Assinaturas */}
        <View style={styles.assinaturaRow}>
          <View style={styles.assinaturaBox}>
            {(
              folha.status === AttendanceSheetStatusEnum.CONCLUIDA ||
              folha.status === AttendanceSheetStatusEnum.AGUARDANDO_REVISAO
            ) && folha.responsavel?.nome && (
                <>
                  <Image
                    src={LogoDefensoria}
                    style={{
                      width: 20,
                      height: 20,
                      marginBottom: 2,
                      alignSelf: 'center',
                    }}
                  />
                  <Text style={{ fontSize: 9, textAlign: 'center', }}>
                    Documento assinado digitalmente por:
                  </Text>
                  <Text>
                    {folha.responsavel.nome}
                  </Text>
                  <Text>
                    em: {assinaturaResponsavel?.criadoEm && `${format(new Date(assinaturaResponsavel.criadoEm), 'dd/MM/yyyy HH:mm:ss', { locale: ptBR })}`}
                  </Text>
                </>
              )}
            <View style={styles.assinaturaLine} />
            {(
              folha.status === AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA ||
              folha.status === AttendanceSheetStatusEnum.EM_PREENCHIMENTO ||
              folha.status === AttendanceSheetStatusEnum.EM_CORRECAO
            ) && folha.responsavel?.nome && (

                <Text style={{ fontSize: 10, textAlign: 'center', marginTop: 2 }}>
                  {folha.responsavel?.nome}
                </Text>
              )}
          </View>
          <View style={styles.assinaturaBox}>
            {(
              folha.status === AttendanceSheetStatusEnum.CONCLUIDA ||
              folha.status === AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA ||
              folha.status === AttendanceSheetStatusEnum.AGUARDANDO_REVISAO
            ) && folha.estagiario?.nome && (
                <>
                  <Image
                    src={LogoDefensoria}
                    style={{
                      width: 20,
                      height: 20,
                      marginBottom: 2,
                      alignSelf: 'center',
                    }}
                  />
                  <Text style={{ fontSize: 9, textAlign: 'center', }}>
                    Documento assinado digitalmente por:
                  </Text>
                  <Text>
                    {folha.estagiario.nome}
                  </Text>
                  <Text>
                    em:{assinaturaEstagiario?.criadoEm && ` ${format(new Date(assinaturaEstagiario.criadoEm), 'dd/MM/yyyy HH:mm:ss', { locale: ptBR })}`}
                  </Text>
                </>
              )}
            <View style={styles.assinaturaLine} />
            {(
              folha.status === AttendanceSheetStatusEnum.EM_PREENCHIMENTO || folha.status === AttendanceSheetStatusEnum.EM_CORRECAO) && folha.estagiario?.nome && (
                <Text style={{ fontSize: 10, textAlign: 'center', marginTop: 2 }}>
                  {folha.estagiario?.nome}
                </Text>
              )}
            {folha.status === AttendanceSheetStatusEnum.CONCLUIDA && <Text style={styles.diahoje}>Validado pela Subdefensoria.</Text>}
          </View>
        </View>
      </Page>
    </Document>
  );
}